import React from 'react';
import './primitives.css';

export type ButtonVariant = 'primary' | 'secondary' | 'subtle' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variant?: ButtonVariant;
  readonly size?: ButtonSize;
  readonly block?: boolean;
  readonly loading?: boolean;
  readonly leftIcon?: React.ReactNode;
  readonly rightIcon?: React.ReactNode;
}

/**
 * SLDS-styled button primitive. Token-driven; variants map to semantic colours.
 * Presentation only — callers own behaviour via `onClick`/`type`.
 */
export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'secondary', size = 'md', block, loading, leftIcon, rightIcon, children, className, disabled, type = 'button', ...rest },
  ref,
): React.ReactElement {
  const classes = [
    'tl-btn',
    `tl-btn--${variant}`,
    size !== 'md' ? `tl-btn--${size}` : '',
    block ? 'tl-btn--block' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <button
      ref={ref}
      type={type}
      className={classes}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading && <span className="tl-btn__spinner" aria-hidden="true" />}
      {!loading && leftIcon}
      {children}
      {!loading && rightIcon}
    </button>
  );
});
